module.exports = __webpack_public_path__ + "img/bank-id-logo.70e7657f.svg";